import { useState } from 'react';

import {
  Delete as DeleteIcon,
  GroupAdd as GroupAddIcon,
  Group as GroupIcon,
  PersonRemove as PersonRemoveIcon,
} from '@mui/icons-material';
import { alpha, Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import CreateCorporateGroup from './CreateCorporateGroup';
import CreateIndividualGroup from './CreateIndividualGroup';
import DeleteCustomerGroupMember from './DeleteCustomerGroupMember';
import DeleteCustomerGroup from './DeleteIndividualCustomerGroup';
import AnimatedBackButton from '../../components/elements/AnimatedBackButton';
import AnimatedCard from '../../components/elements/AnimatedCard';
import HeaderComp from '../../components/elements/HeadingComponent';

const CustomerGroup = () => {
  const [groupType, setGroupType] = useState('');
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const operationOptions = [
    {
      value: 'Create individual group',
      label: 'Create Individual Group',
      description: 'Create a new group for individual customers',
      icon: <GroupAddIcon />,
      color: '#6366f1', // Indigo
      bgColor: alpha('#6366f1', 0.08),
      borderColor: alpha('#6366f1', 0.2),
    },
    {
      value: 'Create corporate group',
      label: 'Create Corporate Group',
      description: 'Create a new group for corporate customers',
      icon: <GroupIcon />,
      color: '#059669', // Emerald
      bgColor: alpha('#059669', 0.08),
      borderColor: alpha('#059669', 0.2),
    },
    {
      value: 'Delete group',
      label: 'Delete Customer Group',
      description: 'Remove an existing customer group',
      icon: <DeleteIcon />,
      color: '#dc2626', // Red
      bgColor: alpha('#dc2626', 0.08),
      borderColor: alpha('#dc2626', 0.2),
    },
    {
      value: 'Delete member',
      label: 'Delete Group Member',
      description: 'Remove a member from a customer group',
      icon: <PersonRemoveIcon />,
      color: '#ea580c', // Orange
      bgColor: alpha('#ea580c', 0.08),
      borderColor: alpha('#ea580c', 0.2),
    },
  ];

  return (
    <>
      <HeaderComp>Customer Group Management</HeaderComp>

      <AnimatedBackButton onClick={handleBackClick} />

      {/* Modern Operation Selection */}
      <Box mb={4}>
        <Grid container spacing={3}>
          {operationOptions.map((option) => (
            <Grid item xs={12} sm={6} md={3} key={option.value}>
              <AnimatedCard
                title={option.label}
                description={option.description}
                icon={option.icon}
                color={option.color}
                bgColor={option.bgColor}
                borderColor={option.borderColor}
                isSelected={groupType === option.value}
                onClick={() => setGroupType(option.value)}
              />
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Selected Component */}
      {groupType && (
        <Box
          sx={{
            mt: 4,
            p: 3,
            borderRadius: 3,
            backgroundColor: 'background.paper',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '1px solid rgba(0,0,0,0.1)',
          }}
        >
          {groupType === 'Create individual group' && <CreateIndividualGroup />}
          {groupType === 'Create corporate group' && <CreateCorporateGroup />}
          {groupType === 'Delete group' && <DeleteCustomerGroup />}
          {groupType === 'Delete member' && <DeleteCustomerGroupMember />}
        </Box>
      )}
    </>
  );
};

export default CustomerGroup;
